// 인라인 스피너 — Tailwind animate-spin + 단순 SVG.
// "불러오는 중..." 텍스트 대체용.

import { useTranslation } from 'react-i18next';

export default function Spinner({ size = 14, className }: { size?: number; className?: string }) {
	const { t } = useTranslation();
	return (
		<svg
			aria-label={t('shell.loading')}
			role="status"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			className={`inline-block animate-spin text-class-blue ${className || ''}`}
		>
			<circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" strokeOpacity="0.2" fill="none" />
			<path d="M22 12a10 10 0 0 1-10 10" stroke="currentColor" strokeWidth="3" fill="none" strokeLinecap="round" />
		</svg>
	);
}
